<template>
  <div :class="{ 'form-control': true, 'is-select': true }">
    <v-select
      class="suggestions-filter"
      :disabled="disabled"
      :options="data"
      v-model="data_id"
      :reduce="reduce"
      :filterBy="filterByUsers"
      :placeholder="placeholder"
      label="name"
      @search="debouncedFetchData">
      <template slot="no-options">
        <template v-if="!empty_results">Trwa wyszukiwanie&hellip;</template>
        <template v-if="empty_results">Brak wyników do wyświetlenia&hellip;</template>
      </template>
      <template
        slot="option"
        slot-scope="option">
        <div class="form-group">
          <div class="d-center drop-name">
            {{ option.name }} {{ option.last_name }}
          </div>
          <div class="d-center">
            <label> Miasto:</label>
            {{ option.city}}
          </div>
          <div class="d-center">
            <label> Kod pocztowy:</label>
            {{ option.post_code}}
          </div>
          <div class="d-center">
            <label> Ulica:</label>
            {{ option.address }}
          </div>
        </div>
      </template>
      <template
        slot="selected-option"
        slot-scope="option">
        <div class="selected d-center">
          {{ option.name }} {{ option.last_name }}
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from '../../utils/FormUtils.js';

export default {
  name: 'filter-suggestion',
  props: {
    dataId: {
      type: [String, Number],
      required: true
    },
    endpointItems: {
      type: String,
      required: true
    },
    endpointItem: {
      type: String,
      required: true
    },
    placeholder: {
      type: String
    },
    reduce: {
      type: Function,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    customerId: {
      type: Number,
      required: true
    }
  },
  watch: {
    data_id (data) {
      this.emitFilterResult(data);
      if (data === '') {
        this.value_search = '';
      }
    }
  },
  data () {
    return {
      data_id: '',
      data: [],
      empty_results: false,
      value_search: ''
    };
  },
  mounted () {
    this.data_id = this.dataId;
    if (this.data_id) {
      this.prefetchData(this.data_id);
    } else {
      this.data_id = '';
      let where = {
        customer_id: this.customerId
      };
      FormUtils.loadAdditionalData(this, {
        endpoint: this.endpointItems,
        outputKey: 'data',
        params: {
          where
        },
        successAction: (response) => {
          if (!response.length) {
            this.empty_results = true;
          }
        }
      });
    }
  },
  methods: {
    emitFilterResult (data) {
      this.$emit('input', data);
    },
    filterByUsers (option, label, search) {
      this.value_search = search;
      return (option.name + ' ' + option.last_name).toLowerCase().indexOf(search.toLowerCase()) > -1 || option.pesel;
    },
    prefetchData (patientID) {
      if (!patientID) {
        return;
      }
      FormUtils.loadAdditionalData(this, {
        endpoint: this.endpointItem + parseInt(patientID, 10),
        outputKey: 'data',
        wrapResponseIntoArray: true,
        successAction: () => {
          this.data_id = parseInt(patientID, 10);
        }
      });
    },
    fetchCustomers (searchPhrase, loadingCallback) {
      this.empty_results = false;
      loadingCallback(true);
      let endpointUrl = this.endpointItems;
      let responseAsArray = false;
      let paramsData = {};

      if (searchPhrase !== '') {
        paramsData.where = {
          search: searchPhrase
        };
      }
      let where = {
        customer_id: this.customerId
      };
      if (this.data_id !== 0 && this.data_id !== '' && searchPhrase === '') {
        endpointUrl = this.endpointItem + parseInt(this.data_id, 10);
        responseAsArray = true;
      }
      setTimeout(() => {
        FormUtils.loadAdditionalData(this, {
          endpoint: endpointUrl,
          outputKey: 'data',
          params: {
            paramsData,
            where
          },
          wrapResponseIntoArray: responseAsArray,
          successAction: (response) => {
            if (!response.length) {
              this.empty_results = true;
            }
            loadingCallback(false);
          }
        });
      }, 800);
    },
    debouncedFetchData: debounce(function (searchPhrase, loadingCallback) {
      this.fetchCustomers(searchPhrase, loadingCallback);
    }, 500),
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/filter-suggestion.scss";
</style>
